import { MIN_SHIFT_LENGTH_FOR_MANDATORY_BREAK_IN_MINUTES } from "@src/appV2/redesign/Shift/constants";

export function getVerificationMessage(
  isSolveUnpaidBreaksEnabled: boolean,
  doesFacilityRequireMandatoryBreak: boolean,
  workDurationInHours: number,
  mandatoryBreakDurationInMinutes: number
): string {
  const workDurationInMinutes = workDurationInHours * 60;
  const baseMessage =
    "You can edit your timesheet after you clock out. Please ensure you get a signature from a facility staff member";

  if (!isSolveUnpaidBreaksEnabled) {
    return baseMessage;
  }

  const requiresMandatoryBreak =
    doesFacilityRequireMandatoryBreak &&
    workDurationInMinutes > MIN_SHIFT_LENGTH_FOR_MANDATORY_BREAK_IN_MINUTES;

  if (requiresMandatoryBreak) {
    return (
      `A ${mandatoryBreakDurationInMinutes}-minute mandatory break will be added to your timesheet. ` +
      `If you skip your break, make sure to adjust your timesheet after clock out. ` +
      `Please ensure to get a signature from a facility staff member.`
    );
  }

  return baseMessage;
}
